import { render, staticRenderFns } from "./sortableList.vue?vue&type=template&id=b23c37f4"
import script from "./sortableList.vue?vue&type=script&lang=js"
export * from "./sortableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports